<div class="positions_container p-3">
  <div class="positions" *ngIf="tournamentTeams.length">
    <table mat-table [dataSource]="positions">
      <ng-container matColumnDef="team">
        <th mat-header-cell *matHeaderCellDef>Equipo</th>
        <td mat-cell *matCellDef="let el">
          <img class="position_team_img" src="{{ getTeamProperty(el.team, 'photo') }}" alt="" />
          <span class="position_team_name">{{
            getTeamProperty(el.team, 'name')
          }}</span>
        </td>
      </ng-container>
      <ng-container matColumnDef="played_matches">
        <th class="position_header" mat-header-cell *matHeaderCellDef>J</th>
        <td mat-cell *matCellDef="let el">{{ el.played_matches }}</td>
      </ng-container>
      <ng-container matColumnDef="won_matches">
        <th class="position_header" mat-header-cell *matHeaderCellDef>G</th>
        <td mat-cell *matCellDef="let el">{{ el.won_matches }}</td>
      </ng-container>
      <ng-container matColumnDef="tied_matches">
        <th class="position_header" mat-header-cell *matHeaderCellDef>E</th>
        <td mat-cell *matCellDef="let el">{{ el.tied_matches }}</td>
      </ng-container>
      <ng-container matColumnDef="lost_matches">
        <th class="position_header" mat-header-cell *matHeaderCellDef>P</th>
        <td mat-cell *matCellDef="let el">{{ el.lost_matches }}</td>
      </ng-container>
      <ng-container matColumnDef="difference">
        <th class="position_header" mat-header-cell *matHeaderCellDef>GF/C</th>
        <td mat-cell *matCellDef="let el">{{ el.goals_in_favor }} / {{el.goals_against}}</td>
      </ng-container>
      <ng-container matColumnDef="points">
        <th class="position_header" mat-header-cell *matHeaderCellDef>PTS</th>
        <td mat-cell *matCellDef="let el">{{ el.points }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>